import { List, Create, Edit } from "../Components/index.js";

export default [
    {
        path: "/admin/areas",
        component: List,
        name: "area-list",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/areas/:id/edit",
        component: Edit,
        name: "area-edit",
        meta: {
            requiresAuth: true,
        },
    },
    {
        path: "/admin/areas/create",
        component: Create,
        name: "area-create",
        meta: {
            requiresAuth: true,
        },
    },
];
